import React, { useState, useEffect } from 'react';
import Navbar from "./Navbar"
import Home from './Home';
import About from './About';
import Skills from './Skills';
import Projects from './Projects';
import Footer from './Footer';
import "./css/style.css"
import { Route,Routes} from 'react-router-dom';
export default function App() {
  const [theme, setTheme] = useState(() => {
    // Initialize theme from localStorage or default to 'light'
    return localStorage.getItem('theme') || 'light';
  });

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('theme', newTheme);
  };

  useEffect(() => {
    // Apply theme to document body for global styling
    document.body.className = `${theme}-mode`;
  }, [theme]);
  return (
      <div className={`scroll ${theme}-mode`}>
        <Navbar theme={theme} toggleTheme={toggleTheme} />
        <main>
          <Routes>
            <Route path="/" element={<Home />}/>
            <Route path="/about" element={<About />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Projects />} />
          </Routes>
        </main>
        <Footer />
      </div>
  );
}
